@defer (when schedules()) {
  @if (schedules().length) {
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Schedule</th>
          @for (scheduleDay of schedules()[0].days; track $index) {
            <th colspan="2" class="text-center day">{{ scheduleDay.day }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (schedule of schedules(); track $index) {
          <tr (click)="clickSchedule(schedule)">
            <td>{{ schedule.title }}</td>
            @for (scheduleDay of schedule.days; track $index) {
              <td class="text-center on">{{ scheduleDay.timeOn ?? '-- : --' }}</td>
              <td class="text-center off">{{ scheduleDay.timeOff ?? '-- : --' }}</td>
            }
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <app-info-panel>No Schedules</app-info-panel>
  }
}

@if (schedule()) {
  <app-site-schedule [siteSchedule]="schedule()" />
}
